import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import { useStyles } from './styles';

const DisplayModeAction = ({ displayModeIsWPN, changeDisplayModeIsWPN }) => {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<Grid container alignItems="center" className={classes.rootContainer}>
			<Grid item>
				<Typography variant="body1">{t('components.productsTable.displayMode.OPN.title')}</Typography>
			</Grid>

			<Grid item className={classes.tooltip}>
				<Tooltip
					title={t('components.productsTable.displayMode.' + (displayModeIsWPN ? 'OPN.tooltip' : 'WPN.tooltip'))}
					aria-label="add"
					className={classes.tooltip}>
					<Switch
						checked={displayModeIsWPN}
						onChange={() => changeDisplayModeIsWPN(!displayModeIsWPN)}
						name="displayModeSwitch"
					/>
				</Tooltip>
			</Grid>

			<Grid item>
				<Typography variant="body1">{t('components.productsTable.displayMode.WPN.title')}</Typography>
			</Grid>
		</Grid>
	);
};

DisplayModeAction.propTypes = {
	displayModeIsWPN: PropTypes.bool.isRequired,
	changeDisplayModeIsWPN: PropTypes.func.isRequired
};

export default DisplayModeAction;
